import filter from "./filter";
import each from "./each";
import find from "./find";
import keys from "./keys";
import map from "./map";
import assign from "./assign";

export default {
    filter: filter,
    each: each,
    keys: keys,
    find: find,
    map: map,
    assign: assign
};
